/* eslint react-hooks/refs: ["warn"] */
import { useUserPreference } from "@coworker/app/src/hooks/useProfilePreferencesQuery";
import { filterValuesAreTheSame } from "../filter/filtervalue";
import { useRef } from "react";
import { FilterValue } from "../../types/filter";

export function useUserPreferenceStoreFilterValues(featureName: string) {
  const fallbackValueRef = useRef<FilterValue[]>([]);
  const [filterValues, setFilterValues] = useUserPreference<FilterValue[]>(
    featureName,
    fallbackValueRef.current
  );

  const storeFilterValues = (values: FilterValue[]) => {
    if (!filterValuesAreTheSame(filterValues, values)) {
      setFilterValues(values);
    }
  };

  return { filterValues, setFilterValues: storeFilterValues };
}
